// TODO: replace with isEditorEmpty or areChildrenEmpty

import { Descendant, Element, Text } from 'slate';
import findNode from '@atlas/tool/box/slate/findNode';
import isVoidBlock from '@atlas/tool/box/slate/isVoidBlock';

export default function isEmptyContent(content: Descendant[]) {
    return !findNode(content, (node) => {
        if (Text.isText(node) && node.text) return true;
        return Element.isElement(node) && isVoidBlock(node);
    });
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isEmptyContent', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
